import { ICouponFiltersValues } from '@pages/coupons/interfaces';
import { conversionFuncs } from '@hooks/useFilters';

export const LIMIT = 25 as const;

export const OFFERS_FIELDS = 'logo_small,name' as const;

export const fileDownloadFormats = [
    {
        name: 'Excel',
        value: 'xls',
    },
    {
        name: 'CSV',
        value: 'csv',
    },
    {
        name: 'XML',
        value: 'xml',
    },
] as const;

export const couponLinksCache = {} as const;

export const LOADING_STUBS = 10 as const;

export const defaultFiltersValue: ICouponFiltersValues = {
    offerId: null,
    typeId: null,
    onlyMyPlacements: false,
    isPersonal: false,
    withPromocode: false,
};

export const filtersConversionFuncs = {
    offerId: conversionFuncs.number,
    typeId: conversionFuncs.number,
    onlyMyPlacements: conversionFuncs.boolean,
    isPersonal: conversionFuncs.boolean,
    withPromocode: conversionFuncs.boolean,
} as const;

export const selectsConfig = [
    {
        id: 'CouponsOffersSelect',
        type: 'offerId',
        isSearchable: true,
        placeholder: 'All offers',
    },
    {
        id: 'CouponsTypesSelect',
        type: 'typeId',
        isSearchable: false,
        placeholder: 'All coupon types',
    },
] as const;
